import Vue from "vue";
import Component from "vue-class-component";
import { Dictionary } from "@/types";
import {
  TransactionsSearchResult,
  InputTransactionsSearch,
  InputTransactionManual,
  Transaction,
} from "@teacherskaya/api-provider/dist/api/TransactionProvider";
import providers from "@/lib/providers";

@Component
export default class WithTransactions extends Vue {
  public transactionsState: TransactionsSearchResult | null = null;

  public transactionsSearch({ data }: { data: InputTransactionsSearch }): Promise<TransactionsSearchResult> {
    return providers.TransactionProvider.find({ data });
  }

  public transactionsCreate({ data }: { data: InputTransactionManual }): Promise<Transaction> {
    return providers.TransactionProvider.createManual({ data });
  }

  public transactionsGetBalance({ userIds }: { userIds: string[] }): Promise<Dictionary<number>> {
    return providers.TransactionProvider.getBalance({ userIds });
  }
}
